var render = function render(){var _vm=this,_c=_vm._self._c;return _c('am-button',{staticClass:"am-submit",class:{
		'is-idle': _vm.state == 'idle',
		'is-loading': _vm.state == 'loading',
		'is-done': _vm.state == 'done'
	},attrs:{"filled":true},on:{"click":function($event){return _vm.$emit('click', _vm.state)}}},[_c('div',{staticClass:"am-submit__send"},[_c('am-icon',{attrs:{"name":"send","dark":true,"size":"sm"}}),_vm._v(" Enviar ")],1),_c('div',{staticClass:"am-submit__sent"},[_c('am-icon',{attrs:{"name":"check","dark":true,"size":"sm"}}),_vm._v(" Enviado ")],1),_c('img',{staticClass:"am-submit__loading",attrs:{"src":"/images/loading.svg"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }